import '@fontsource/schibsted-grotesk/400.css';
import '@fontsource/schibsted-grotesk/500.css';
import '@fontsource/schibsted-grotesk/600.css';
import '@fontsource/schibsted-grotesk/700.css';
import '@fontsource/schibsted-grotesk/800.css';
import '@fontsource/martian-mono/400.css';
import '@fontsource/martian-mono/500.css';
import '@fontsource/martian-mono/600.css';
import './styles/tokens.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { CloudLoggingInitializer } from './components/CloudLoggingInitializer';
import { installCspViolationReporter } from './services/cspViolationReporter';
import './index.css';

installCspViolationReporter();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <CloudLoggingInitializer>
      <App />
    </CloudLoggingInitializer>
  </React.StrictMode>,
);
